import { Helmet } from "react-helmet-async";

/** Reusable SEO wrapper. Renders per-page meta + JSON-LD when props provided. */
export const SEO = ({
  title,
  description,
  canonical,
  image,
  type = "website",
  jsonLd,
}) => {
  const fullTitle = title
    ? `${title} — Əmlak PRO`
    : "Əmlak PRO — Azərbaycanda daşınmaz əmlak axtarışı";
  const desc = description ||
    "Azərbaycanda daşınmaz əmlak axtarış sistemi. Bakı, Sumqayıt, Gəncə və bütün rayonlar üzrə satılıq və kirayə elanları.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};
